<script setup>
import { ref } from 'vue'

defineProps({
	updatePage: {
		type: Function,
		required: true,
	},
	autoHideNav: ref(true),
});
</script>

<template>
<div>
	<h1>About Us</h1>
	<p>This service is offered by <a href="https://brownjuice.co" target="_blank">Brown Juice Co</a>, a software-design agency based in Tokyo.</p>
	<p>Our team has worked on design systems, consumer products, business products, and websites for major companies including Apple, Google, Amazon, Microsoft, and more.</p>
	<p>We&#8217;ve lead the design at technology incubators, including Toyota&#8217;s &#8220;Woven City&#8221; incubator for city-tech and T-Mobile&#8217;s &#8220;Cloud Center&#8221;.</p>
	<p>Today our team provides design and development support for corporations looking to improve their products for user-experience, scalability, and usefulness.</p>
	<p>We also devote a portion of our resources to developing products like this one meant to help new designers find their feet.</p>

	<h2>Help Us Spread The Word</h2>
	<p>The &#8220;Design Externship&#8221; is a new product, and we&#8217;re offering it completely for free.</p>
	<p>If you find any value in the info here, it would be a huge help to us if you could tell your friends, post about us online, tag us on social media, etc.</p>
	<p>We want to make the most valuable products we can, so we can devote more resources to building this service is we see that we're getting more users.</p>

	<h2>Chip in <span class="emoji">🪙</span></h2>
	<p>We're totally self-sponsored and we want to avoid using ads or creating "premium" subscriptions for as long as possible.</p>
	<p>If you have some change you can spare and want to help us pay for the servers and storage, we set up funds on <a href="https://ko-fi.com/brownjuiceco" target="_blank">Ko-fi</a> and '<a href="buymeacoffee.com/brownjuiceco" target="_blank">Buy Me A Coffee</a>' to make it easy to contribute.</p>
	<footer :class="{hidden: !autoHideNav}">
		<a
			@click.stop="updatePage('support', 'contact')"
		>Contact</a>
		<a
			@click.stop="updatePage('support', 'privacy')"
		>Privacy Policy</a>
		<a
			@click.stop="updatePage('support', 'terms')"
		>Terms of Service</a>
	</footer>
</div>
</template>

<style lang="scss" scoped>
footer {
	display: flex;
	justify-content: space-between;
	padding: 1em 0;
}
h2 {
	margin-top:1.5em;
	margin-bottom:6px;
	& + p {margin-top:0;}
}
a { color: var(--link); }
</style>
